import * as fromResetActions from "./reset.actions";
import { ActionReducer } from "@ngrx/store";
import { initialStates } from "../../../vas/store/bootstrap";

/**
 * This reducer will handle the reset action
 * @param reducer
 * @returns {(state:any, action:any)=>any}
 */
export const resetReducer = (reducer): ActionReducer<any> => {
    return (state, action) => {
        state = state || {};

        if (action.type === fromResetActions.RESET) {
            const stateEmpty = {};

            Object.keys(state).map(entity => {
                stateEmpty[entity] = initialStates[entity];
            });
            console.log("STATE HAS BEEN RESET");
            state = stateEmpty;
        }

        return reducer(state, action);
    };
};



// WEBPACK FOOTER //
// ./src/core/store/reset-state/reset.reducer.ts